import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { UI_DetailCard } from 'ui/components/2-molecules/Card/DetailCard/DetailCard';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MainRegion } from '1-project/MainRegion/MainRegion';

interface Props extends Content.Page {
	properties: Content.ContactPersonPageProperties;
}

export const ContactPersonPage = (props: Props) => {
	const { properties } = props;
	const { pageSections, contactPerson } = properties ?? {};
	const { contactPersonPageLink, description, title, email, image, name, organisation, phone } = contactPerson ?? {};
	const dictionary = useDictionaryContext();

	const details = [
		{
			heading: dictionary.getContact?.('Email'),
			text: email,
		},
		{
			heading: dictionary.getContact?.('Phone'),
			text: phone,
		},
	];

	return (
		<MainRegion
			header={
				<UI_HeaderCard
					heading={contactPersonPageLink?.name ? contactPersonPageLink?.name : name}
					teaser={description}
					subeHeading={
						title || organisation ? `${title ? title : ''}${title && organisation ? ',' : ''} ${organisation ? organisation : ''}` : null
					}
					image={
						image
							? {
									url: image.url,
									focalPoint: { left: image.focalPoint?.left, top: image.focalPoint?.top },
								}
							: undefined
					}
					imageAltText=""
					roundImage
				/>
			}
		>
			<UI_DetailCard items={details} />
			<UI_Container width="Small">
				{pageSections.map((sectionModule, index) => (
					<DynamicModule key={index} module={sectionModule} />
				))}
			</UI_Container>
			<GoToTopNavigation />
		</MainRegion>
	);
};
